import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {UsersService} from '../../../Services/users.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {InvoiceDealer} from '../../../Models/InvoiceDealer';
import {DealersService} from '../../../Services/dealers.service';

@Component({
  selector: 'app-archive-dealer-view',
  templateUrl: './archive-dealer-view.component.html',
  styleUrls: ['./archive-dealer-view.component.scss']
})
export class ArchiveDealerViewComponent implements OnInit {
  public grid: Grid;
  public dealerId: number;
  public companyName: string;
  @ViewChild('usersRowDetail', {static: false}) usersRowDetail: any;
  @ViewChild('readdModel', {static: false}) readdModel = null;

  constructor(private router: Router, private dealersService: DealersService, private translateService: TranslateService,
              private broadCastService: BroadcastService) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.invoice_dealer.dealer_number',
          prop: 'debtor',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.companyName',
          prop: 'companyName',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.contact',
          prop: 'contact',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.email',
          prop: 'email',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.phone',
          prop: 'phone',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case InvoiceDealer.INVOICEDEALER_ACTIVE:
                return this.translateService.instant('global.active');
              case InvoiceDealer.INVOICEDEALER_ON_HOLD:
                return this.translateService.instant('global.status_on_hold');
              case InvoiceDealer.INVOICEDEALER_INACTIVE:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-plus fa-lg',
              tooltip: 'global.readd',
              onclick: row => {
                this.dealerId = row.id;
                this.companyName = row.companyName.bold();
                this.readdModel.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.dealersService,
      rememberURL: this.router.url,
      method: 'getDealers',
      defaultSort: 'debtor',
      rowDetailTemplate: this.usersRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      archive: true
    };
  }

  readd() {
    this.dealersService.readdDealer(this.dealerId).subscribe((res) => {
      this.broadCastService.broadcast('refreshGrid', 'getDealers');
      this.readdModel.hide();
    });
  }

  backToOverview() {
    this.router.navigateByUrl('back-office/crm/dealer/overview');
  }

}
